/**
 *
 */
export enum CustomGraphType {
    COOLING_LOAD = "coolingLoad",
    POWER = "power"
}